import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animated, useSpring } from 'react-spring';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { IconArrowDownHollow } from '@design-system/icon';
import { CheckboxInput } from '@design-system/inputs';
import { useTheme } from '@design-system/theme';
const AnimatedBox = animated(Box);
const TitleStyled = styled(AnimatedBox).attrs(() => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
})) `
  cursor: pointer;
  user-select: none;
`;
export const AccordionTitle = ({ checked, disabled, handleChangeCheckbox, isOpen, title, type, }) => {
    const theme = useTheme();
    const springTitle = useSpring({
        rotate: isOpen ? 180 : 0,
    });
    return (_jsxs(TitleStyled, { children: [_jsx(Box, { mr: 2, onClick: (event) => event.stopPropagation(), onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                        event.stopPropagation();
                        if (!disabled) {
                            handleChangeCheckbox(type, event);
                        }
                    }
                }, opacity: type === 'required' ? 0.5 : 1, children: _jsx(CheckboxInput, { checked: checked, disabled: disabled, id: `${title}_checkbox`, label: title, name: `${title}_${type}`, onChange: (event) => {
                        event.stopPropagation();
                        handleChangeCheckbox(type, event);
                    } }) }), _jsx(AnimatedBox, { "aria-expanded": "false", color: theme.colors.primary, mr: 2, style: {
                    transform: springTitle.rotate.to((rotate) => `rotate(${rotate}deg)`),
                }, tabIndex: 0, children: _jsx(IconArrowDownHollow, { size: 30 }) })] }));
};
//# sourceMappingURL=AccordionTitle.js.map